'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('@deskpro/apps-components-style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AppBody = function AppBody(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return _react2.default.createElement(
    'section',
    { className: (0, _classnames2.default)("dp-AppBody dp-Section", className) },
    children
  );
};

AppBody.propTypes = {

  /**
   * any additional classnames to be applied to the AppBar container
   */
  className: _propTypes2.default.string,

  /**
   * a list of children to render.
   */
  children: _propTypes2.default.array
};

exports.default = AppBody;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-components/lib/AppBody/index.js
// module id = 173
// module chunks = 0